import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TypedFormControl } from 'osn-shared';
import { MultiSelectOption } from '../multi-select/multi-select.component';

@Component({
  selector: 'osn-cxb-country-targeting-control',
  templateUrl: './country-targeting-control.component.html',
  styleUrls: ['./country-targeting-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountryTargetingControlComponent implements OnInit {
  @Input() public countryOptions: MultiSelectOption[];
  @Input() public countryIdsControl: TypedFormControl<string[]>;
  @Input() public readonly = false;
  @Input('data-testid') public testId = 'country-targeting-control-component';

  constructor() {}

  public ngOnInit(): void {}
}
